import types from "./types";
import connection from "../api/config/connection";

const requestProducts = (url) => (dispatch) => {
  dispatch({
    type: types.REQUEST_PRODUCTS,
  });

  if (!url) {
    console.error("Cannot request shop products: Missing url");
    dispatch(failedProducts());
    return;
  }

  const options = {
    method: "GET",
    url,
  };

  connection
    .instance()(options)
    .then((response) => {
      let result = {};
      try {
        result = response.data || {};
      } catch (ex) {}

      dispatch(receivedProducts(result));
    })
    .catch((xhr) => {
      dispatch(failedProducts());
    });
};

const receivedProducts = (productsInfo) => ({
  type: types.RECEIVED_PRODUCTS,
  productsInfo,
});
const failedProducts = () => ({
  type: types.REQUEST_PRODUCTS_FAILED,
});
const productsFiltersChanged = (filters) => ({
  type: types.PRODUCTS_FILTERS_CHANGED,
  filters,
});

export default {
  requestProducts,
  failedProducts,
  receivedProducts,
  productsFiltersChanged,
};



// WEBPACK FOOTER //
// ./src/actions/shop.js